import 'jquery-serializejson';
import moment from 'moment';
import BaseModal from 'app/views/modals/base_modal';

import FulfillmentWarehouseDropdownSelection from 'app/models/fulfillment_warehouse_dropdown_selection';
import FulfillmentWarehouse from 'app/models/fulfillment_warehouse';
import DatepickerRangeView from 'app/views/datepicker_range_view';
import SelectorView from 'app/views/selector_view';
import UploadFileView from 'app/components/upload_file_button';
import LoaderView from 'app/views/loader_view';
import tmpl from './template';

export default BaseModal.extend({
  compiledTemplate: tmpl,

  events: {
    'click .cancel': 'closeModal',
    'click .create_bol': 'save',
  },

  closeModal() {
    this.close();
  },

  initialize({
    apiModeSelection,
    bol,
    estimatedDelivery,
    warehouse,
    trackingCode,
    bolCSV,
    loading,
  }) {
    this.apiModeSelection = apiModeSelection;
    this.bol = bol;
    this.estimatedDelivery = estimatedDelivery;
    this.warehouse = warehouse;
    this.trackingCode = trackingCode;
    this.bolCSV = bolCSV;
    this.loading = loading;

    this.addSubview(
      'deliverySelector', '#estimated_delivery',
      new DatepickerRangeView({
        label: 'Estimated Delivery Date',
        model: this.bol,
        options: { singleDatePicker: true, minDate: moment().utc(), maxDate: moment().utc().add(6, 'months') },
      }),
    );
    this.addSubview('warehouseAddress', '#warehouse_location', new SelectorView({ model: new FulfillmentWarehouseDropdownSelection({ apiModeSelection: this.apiModeSelection, collection: this.collection.warehouses }) }));
    this.addSubview('attachCSV', '#attach_csv', new UploadFileView({
      buttonText: 'Attach CSV',
      buttonClass: 'btn-secondary',
      apiModeSelection: this.apiModeSelection,
      callback: options => {
        const button = this.getSubview('attachCSV');
        this.bolCSV = options.data;
        button.buttonText = 'File Attached';
        button.filename = options.file.name;
        options.complete();
      },
    }));
    this.addSubview('loader', '#bol_upload_loader', new LoaderView({}));
  },

  context() {
    return {
      loading: this.loading,
    };
  },

  save() {
    const data = this.$('form').serializeJSON();
    this.loading = true;
    this.render();
    this.bol.set({
      apiModeSelection: this.apiModeSelection,
      estimated_delivery: data.date_range,
      warehouse: new FulfillmentWarehouse({ id: data.warehouse }),
      tracking_code: data.tracking_code,
    });
    this.bol.uploadBolsCSV({
      data: this.bolCSV,
      success: () => {
        this.trigger('create:success', this.bol);
        this.close();
      },
      error: error => {
        this.loading = false;
        this.render();
        this.trigger('create:error', error);
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/fulfillment_bols/create/modal/index.js